// src/App.tsx
import React, { useState, useRef, useEffect } from 'react';
import { Preloader } from './components/Preloader';
import { resources } from './assets/resources';
import { Routes, Route } from 'react-router-dom';
import { WelcomePage } from './pages/Welcome';
import { LearnPage } from './pages/Learn';
import { CabinetPage } from './pages/Cabinet';
import { useSound } from './context/SoundContext';

function App() {
    const [loaded, setLoaded] = useState(false);
    // @ts-ignore
    const { muted, toggleMuted } = useSound();

    const audioRef = useRef<HTMLAudioElement | null>(null);

    useEffect(() => {
        if (!audioRef.current) return;
        audioRef.current.muted = muted;
        audioRef.current.volume = 0.3;
    }, [muted, loaded]);

    if (!loaded) {
        return <Preloader resources={resources} onLoaded={() => setLoaded(true)} />;
    }

    return (
        <>
            {!muted && (
                <audio
                    ref={audioRef}
                    src={`${process.env.PUBLIC_URL}/audio/sound.mp3`}
                    autoPlay
                    playsInline
                    loop
                />
            )}

            <Routes>
                <Route path="/" element={<WelcomePage />} />
                <Route path="/learn" element={<LearnPage />} />
                <Route path="/cabinet" element={<CabinetPage />} />
            </Routes>
        </>
    );
}

export default App;
